import { useAtomValue } from 'jotai';
import { USER_ROLE_READONLY } from '@utils/constants';
import { useResetAtom } from 'jotai/utils';
import * as atoms from './atom';

export const useResetState = () => {
  const resetFilterCreate = useResetAtom(atoms.filterCreate);
  const resetFilterEditor = useResetAtom(atoms.filterEditor);
  const resetFilterClone = useResetAtom(atoms.filterClone);

  const reset = () => {
    resetFilterCreate();
    resetFilterEditor();
    resetFilterClone();
  };

  return {
    reset,
    resetFilterCreate,
    resetFilterEditor,
    resetFilterClone
  };
};

export const useFilterPanelVisible = () => {
  const filterCreate = Boolean(useAtomValue(atoms.filterCreate));
  const filterEditor = Boolean(useAtomValue(atoms.filterEditor));
  const filterClone = Boolean(useAtomValue(atoms.filterClone));
  return {
    isVisible: filterCreate || filterEditor || filterClone,
    isFilterCreateVisible: filterCreate,
    isFilterEditorVisible: filterEditor,
    isFilterCloneVisible: filterClone,
  };
};

export const useReadOnlyRole = () => {
  const user = useAtomValue(atoms.user);
  return user.role === USER_ROLE_READONLY;
};